module.exports = __webpack_public_path__ + "img/xichuan.bc3bbb74.png";